export default __webpack_public_path__ + "static/media/eastside-crop.08079a1e.jpg";